package com.eladfinish.bible.contest.screens.openQuestions.model

import androidx.compose.runtime.Immutable

@Immutable
data class QuestionItem(
    val question: String,
    val answer: String,
    val author: String,
    val book: String = "",
    val chapter: String = "",
    val verse: String = "",
    val regex: String = "",
    val isAnswerVisible: Boolean = false,
    val num: Int = 0,
) {
    val sourceLabel: String
        get() = openQuestionSourceLabel(book, chapter, verse)

    val hasSource: Boolean get() = book.isNotEmpty()
    val hasRegex: Boolean get() = regex.isNotEmpty()

    /** Text shown in the bottom chip of the card.
     *  Author questions → "תודה ל[author]", sourced questions → "[Book Chapter]", otherwise empty. */
    val chipLabel: String
        get() = when {
            author.isNotEmpty() -> "תודה ל$author"
            else -> sourceLabel
        }

    fun withToggledVisibility(): QuestionItem = copy(isAnswerVisible = !isAnswerVisible)

    fun toDisplayString(): String = buildString {
        append(question)
        append("\n")
        append(answer)
        if (sourceLabel.isNotEmpty()) append(" $sourceLabel")
        if (author.isNotEmpty()) append("\nמחבר/ת: $author")
    }.trim()
}
